export const CONTEXT_NAMES = {
  CompaniesContext: 'CompaniesContext',
  AlloyLaunchDarklyContext: 'AlloyLaunchDarklyContext',
  ProjectEntitlementsContext: 'ProjectEntitlementsContext',
  AccountEntitlementsContext: 'AccountEntitlementsContext',
  ProjectsContext: 'ProjectsContext',
  RolesContext: 'RolesContext',
  UserContext: 'UserContext',
  UsersContext: 'UsersContext',
  DeletedUsersContext: 'DeletedUsersContext',
  RelationshipsContext: 'RelationshipsContext',
  EntitiesCacheContext: 'EntitiesCacheContext',
  SideNavigationContext: 'SideNavigationContext',
  CurrentProjectIdContext: 'CurrentProjectIdContext',
  CurrentAccountIdContext: 'CurrentAccountIdContext',
  CurrentProductIdContext: 'CurrentProductIdContext',
  CurrentToolIdContext: 'CurrentToolIdContext',
  SubscriptionsContext: 'SubscriptionsContext'
};
//# sourceMappingURL=globalContexts.js.map